if (!customElements.get('byte-complementary-products')) {
    class ByteComplementaryProducts extends HTMLElement {
        constructor() {
            super();

            this.boundHandleToggle = this.handleToggle.bind(this);
            this.boundHandleClick = this.handleClick.bind(this);
            this.boundHandleScroll = this.handleScroll.bind(this);
            this.boundHandleResize = this.handleResize.bind(this);
        }

        connectedCallback() {
            this.detailsElement = this.querySelector('details');
            this.sliderTrack = this.querySelector('[data-complementary-slider]');
            this.prevButton = this.querySelector('[data-complementary-action="prev"]');
            this.nextButton = this.querySelector('[data-complementary-action="next"]');

            if (this.detailsElement) {
                this.detailsElement.addEventListener('toggle', this.boundHandleToggle);
            }

            if (this.sliderTrack) {
                this.sliderTrack.addEventListener('scroll', this.boundHandleScroll, { passive: true });
                this.resizeObserver = new ResizeObserver(this.boundHandleResize);
                this.resizeObserver.observe(this.sliderTrack);
            }

            this.addEventListener('click', this.boundHandleClick);

            if (this.detailsElement?.open) {
                this.#scheduleSliderUpdate();
            }
        }

        disconnectedCallback() {
            if (this.detailsElement) {
                this.detailsElement.removeEventListener('toggle', this.boundHandleToggle);
            }

            if (this.sliderTrack) {
                this.sliderTrack.removeEventListener('scroll', this.boundHandleScroll);
            }

            this.resizeObserver?.disconnect();
            this.removeEventListener('click', this.boundHandleClick);
        }

        handleToggle() {
            if (!this.detailsElement?.open) return;

            this.#scheduleSliderUpdate();
        }

        handleClick(event) {
            const actionTrigger = event.target.closest('[data-complementary-action]');
            if (!actionTrigger || !this.contains(actionTrigger)) return;

            const complementaryAction = actionTrigger.dataset.complementaryAction;

            if (complementaryAction === 'prev') {
                this.#scrollByStep(-1);
            }

            if (complementaryAction === 'next') {
                this.#scrollByStep(1);
            }
        }

        handleScroll() {
            this.#updateNavState();
        }

        handleResize() {
            this.#updateNavState();
        }

        #scheduleSliderUpdate() {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    this.#updateNavState();
                });
            });
        }

        #scrollByStep(direction) {
            if (!this.sliderTrack) return;

            const firstSlide = this.sliderTrack.querySelector('.byte-complementary-products__item');
            if (!firstSlide) return;

            const trackStyles = window.getComputedStyle(this.sliderTrack);
            const gapValue = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
            const scrollStep = firstSlide.offsetWidth + gapValue;

            this.sliderTrack.scrollBy({
                left: direction * scrollStep,
                behavior: 'smooth',
            });
        }

        #updateNavState() {
            if (!this.sliderTrack || !this.prevButton || !this.nextButton) return;

            const maxScrollLeft = this.sliderTrack.scrollWidth - this.sliderTrack.clientWidth;
            const hasOverflow = maxScrollLeft > 1;

            this.classList.toggle('has-overflow', hasOverflow);

            if (!hasOverflow) {
                this.prevButton.setAttribute('disabled', '');
                this.nextButton.setAttribute('disabled', '');
                return;
            }

            if (this.sliderTrack.scrollLeft <= 1) {
                this.prevButton.setAttribute('disabled', '');
            } else {
                this.prevButton.removeAttribute('disabled');
            }

            if (this.sliderTrack.scrollLeft >= maxScrollLeft - 1) {
                this.nextButton.setAttribute('disabled', '');
            } else {
                this.nextButton.removeAttribute('disabled');
            }
        }
    }

    customElements.define('byte-complementary-products', ByteComplementaryProducts);
}
